export default __webpack_public_path__ + "static/shopify-plus-d908abdf7fd7397ece73893c19eeefc7.png";